"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tenantShortBrandMap = exports.tenantBrandMap = void 0;
const enums_1 = require("./enums");
exports.tenantBrandMap = {
    [enums_1.TenantEnum.JS_AT]: enums_1.Brand.JochenSchweizer,
    [enums_1.TenantEnum.JS_DE]: enums_1.Brand.JochenSchweizer,
    [enums_1.TenantEnum.JS_NOW_DE]: enums_1.Brand.JochenSchweizer,
    [enums_1.TenantEnum.JS_TEST]: enums_1.Brand.JochenSchweizer,
    [enums_1.TenantEnum.MD_AT]: enums_1.Brand.Mydays,
    [enums_1.TenantEnum.MD_CH]: enums_1.Brand.Mydays,
    [enums_1.TenantEnum.MD_DE]: enums_1.Brand.Mydays,
    [enums_1.TenantEnum.MD_TEST]: enums_1.Brand.Mydays,
};
exports.tenantShortBrandMap = {
    [enums_1.TenantEnum.JS_AT]: enums_1.ShortBrand.JochenSchweizer,
    [enums_1.TenantEnum.JS_DE]: enums_1.ShortBrand.JochenSchweizer,
    [enums_1.TenantEnum.JS_NOW_DE]: enums_1.ShortBrand.JochenSchweizer,
    [enums_1.TenantEnum.JS_TEST]: enums_1.ShortBrand.JochenSchweizer,
    [enums_1.TenantEnum.MD_AT]: enums_1.ShortBrand.Mydays,
    [enums_1.TenantEnum.MD_CH]: enums_1.ShortBrand.Mydays,
    [enums_1.TenantEnum.MD_DE]: enums_1.ShortBrand.Mydays,
    [enums_1.TenantEnum.MD_TEST]: enums_1.ShortBrand.Mydays,
};
//# sourceMappingURL=brands.js.map